import { render, staticRenderFns } from "./ProductQuotationModal.vue?vue&type=template&id=6fa6fd91&scoped=true&"
import script from "./ProductQuotationModal.vue?vue&type=script&lang=ts&"
export * from "./ProductQuotationModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductQuotationModal.vue?vue&type=style&index=0&id=6fa6fd91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6fd91",
  null
  
)

export default component.exports